import { createAction } from 'redux-act';
import { ICall, ICallParticipant  } from '@app-types/websocket/calls.types';

export const newCall = createAction<ICall>('new call');
export const callHistory = createAction<number>('get call history');
export const callAction = createAction<ICallParticipant>('respond to call');
export const allowCalls = createAction<boolean>('allow calls');
export const callNotification = createAction<number>('Call notification received');



// WEBPACK FOOTER //
// ./src/services/calls/calls.actions.ts